import { render, staticRenderFns } from "./QuiltyResourceEditView.vue?vue&type=template&id=0de369e9&"
import script from "./QuiltyResourceEditView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports